import { useState } from 'react';
import { Backdrop, Box } from '@mui/material';
import Paper from '@mui/material/Paper';

const ImagePreviewListener = ({ children }) => {
    const [imageForFullViewSrc, setImageForFullViewSrc] = useState('');

    // handles preview and full view image clicks
    const imgClickListener = (event) => {
        if (event.target.nodeName !== 'IMG') {
            return;
        }

        setImageForFullViewSrc((prevImageForFullViewSrc) => (prevImageForFullViewSrc ? '' : event.target.currentSrc));
    };

    const backdropClickListener = (e) => {
        e.stopPropagation();
        setImageForFullViewSrc('');
    };

    return (
        <Box onClick={imgClickListener}>
            {children}
            <Backdrop
                sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={Boolean(imageForFullViewSrc)}
                onClick={backdropClickListener}
            >
                <Box
                    sx={{
                        height: `80vh`,
                        maxWidth: '80vw',

                        backgroundColor: 'unset',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <Paper
                        component="img"
                        sx={{
                            userSelect: 'none',
                            maxWidth: '100%',
                            maxHeight: '100%',
                            objectFit: 'contain',
                            borderRadius: '8px',
                            cursor: 'pointer',
                        }}
                        src={imageForFullViewSrc}
                        alt=""
                        variant="elevation"
                        elevation={4}
                    />
                </Box>
            </Backdrop>
        </Box>
    );
};

export default ImagePreviewListener;
